import { v4 as uuidv4 } from 'uuid';

export class PeatPineYield {
  peatYieldId: string = uuidv4();
  id: String;
  peatType: 'Property' | 'Paddock';
  product: 'Large Sawlogs' | 'Small Sawlogs' | 'Posts' | 'Pulplogs';
  yieldKey: string;
  thinAge: number;
  harvestAge: number;
  yields: Record<number, number>;
}
